import { h } from 'vue';

// Utils
import { Text } from '@/utils';

// Mixinx
import { props, computed, methods } from './mixin';

export default {

    mixins: [props, computed, methods],

    props:
    {
        label:
        {
            type: String,
            default: ''
        },

        menuPosition:
        {
            type: String,
            default: '',
        }
    },

    data()
    {
        return {
            openDropdown: false,
        };
    },

    mounted()
    {
        window.addEventListener('click', this.handleClickOutside);
    },

    beforeUnmount()
    {
        window.removeEventListener('click', this.handleClickOutside);
    },

    methods:
    {
        close()
        {
            this.openDropdown = false;
        },

        handleClickOutside(event)
        {
            if (!this.$refs.buttonDropdown.contains(event.target))
            {
                if (this.openDropdown)
                {
                    this.openDropdown = false;
                }
            }
        },
    },

    render()
    {
        return h(
            'div',
            {
                class: 'vh-button-dropdown',

                ref: 'buttonDropdown'
            },

            [
                h(
                    'button',
                    {
                        class: [
                            this.classes,

                            this.divClass
                        ],

                        onClick: () => this.openDropdown = !this.openDropdown,
                    },

                    this.loading
                        ? h(
                            'transition',
                            {
                                on:
                                {
                                    name: 'fade',
                                    mode: 'out-in',
                                },
                            },
                            [
                                h(
                                    'i',
                                    {
                                        class: Text.joinClass(
                                            'fa',
                                            'fa-spinner',
                                            'fa-lg',
                                            'vh-animate',
                                            'vh-animate-infinite',
                                            'vh-animate-rotate'
                                        ),
                                    }
                                ),
                            ]
                        )
                        : [
                            this.$slots.label
                            ? this.$slots.label()
                            : h(
                                'small',

                                [
                                    h(
                                        'span',
                                        {
                                            class: 'vh-margin-xsmall-right ',
                                        },
                                        
                                        this.label
                                    ),

                                    h(
                                        'i',
                                        {
                                            class: `fa fa-caret-down`
                                        }
                                    )
                                ]
                            ),
                        ]
                    
                ),

                h(
                    'ul',
                    {
                        class: [
                            'vh-menu',
                           this.menuPosition && `vh-menu-${this.menuPosition}`,

                            this.openDropdown && 'vh-menu-show'
                        ],
                    },

                    this.$slots.menu()
                )
            ]
        )
        
        
        
    },
};
